import VectorLayer from 'ol/layer/Vector';
import Transform from 'ol-ext/interaction/Transform';
import { del, ref, set } from 'vue-demi';
import VectorSource from 'ol/source/Vector';
import { getCenter } from 'ol/extent';
import Circle from 'ol/geom/Circle';
import { Feature } from 'ol';
import { transformCoordinates, transformCoordinatesToLonLat } from './utils';
import { Fill, Stroke, Style } from 'ol/style';
import CircleStyle from 'ol/style/Circle';
import Point from 'ol/geom/Point';
import { always, shiftKeyOnly } from 'ol/events/condition';
import { colors } from './utils/data';
import { asArray } from 'ol/color';
import { fromExtent } from 'ol/geom/Polygon';
import { getPointResolution } from 'ol/proj';

Transform.prototype.Cursors['rotate'] =
  "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXAgMAAACdRDwzAAAAAXNSR0IArs4c6QAAAAlQTFRF////////AAAAjvTD7AAAAAF0Uk5TAEDm2GYAAAABYktHRACIBR1IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH2wwSEgUFmXJDjQAAAEZJREFUCNdjYMAOuCCk6goQpbp0GpRSAFKcqdNmQKgIILUoNAxIMUWFhoKosNDQBKDgVAilCqcaQBogFFNoGNjsqSgUTgAAM3ES8k912EAAAAAASUVORK5CYII=') 5 5, auto";
Transform.prototype.Cursors['rotate0'] =
  "url('data:image/png;base64,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') 5 5, auto";

export function useMapLandmarks(map) {
  const selectedLandmarkIds = ref({});
  const editLandmarksState = ref({});
  const visibleLandmarkLayer = ref(false);

  const source = new VectorSource({
    projection: 'EPSG:3857',
    features: []
  });

  function getRadius(radius, center) {
    return radius / getPointResolution('EPSG:3857', 1, center);
  }

  function getStyle(feature) {
    const selected = feature.get('selected');
    const colorName = feature.get('color');
    const color = asArray(colors[colorName] || colors.default);
    const alphaColor = color.slice();
    alphaColor[3] = selected ? 0.5 : 0.3;
    return [
      new Style({
        fill: new Fill({ color: alphaColor }),
        stroke: new Stroke({ color, width: 1 })
      }),
      new Style({
        image: new CircleStyle({
          radius: 3,
          fill: new Fill({
            color
          })
        }),
        geometry: function(feature) {
          var coordinates = getCenter(feature.getGeometry().getExtent());
          return new Point(coordinates);
        }
      })
    ];
  }

  const landmarkLayer = new VectorLayer({
    source: source,
    style: getStyle,
    wrapX: false
  });

  const interaction = new Transform({
    enableRotatedTransform: true,
    translateBBox: true,
    addCondition: shiftKeyOnly,
    hitTolerance: 2,
    translateFeature: true,
    scale: true,
    keepAspectRatio: always,
    translate: true,
    stretch: true,
    layers: [landmarkLayer],
    selection: false
  });

  const updateEditLandmarkState = (
    landmarkId,
    { radius, centerLat, centerLon }
  ) => {
    editLandmarksState.value = {
      ...editLandmarksState.value,
      [landmarkId]: {
        radius,
        centerLat,
        centerLon
      }
    };
  };

  interaction.on('translating', function(e) {
    const landmarkId = e.feature.getId();
    const extent = e.feature.getGeometry().getExtent();
    const [centerLon, centerLat] = transformCoordinatesToLonLat(
      getCenter(extent)
    );
    const radius =
      e.feature.getGeometry().getRadius() *
      getPointResolution('EPSG:3857', 1, getCenter(extent));
    updateEditLandmarkState(landmarkId, {
      radius,
      centerLat,
      centerLon
    });
  });
  interaction.on('scaling', function(e) {
    const landmarkId = e.feature.getId();
    const extent = e.feature.getGeometry().getExtent();
    const [centerLon, centerLat] = transformCoordinatesToLonLat(
      getCenter(extent)
    );
    const radius =
      e.feature.getGeometry().getRadius() *
      getPointResolution('EPSG:3857', 1, getCenter(extent));
    updateEditLandmarkState(landmarkId, {
      radius,
      centerLat,
      centerLon
    });
  });

  interaction.setActive(false);
  map.addInteraction(interaction);

  const setMapToLandmarkCenter = landmarkId => {
    const landmark = source.getFeatureById(landmarkId);
    if (landmark) {
      map.getView().animate({
        center: getCenter(landmark.getGeometry().getExtent()),
        duration: 1000
      });
      map.getView().fit(landmark.getGeometry(), {
        padding: [100, 100, 100, 100],
        duration: 700
      });
    }
  };

  const setLandmarks = landmarks => {
    clearLandmarks();
    source.addFeatures(
      landmarks.map(({ id, center, radius, color }) => {
        radius = getRadius(radius, transformCoordinates(center));
        const feature = new Feature({
          geometry: new Circle(transformCoordinates(center), radius)
        });
        feature.set('color', color);
        feature.set('selected', !!selectedLandmarkIds.value[id]);
        feature.setId(id.toString());
        return feature;
      })
    );
  };

  const selectFeature = (feature, selected) => {
    feature.set('selected', selected);
    selected
      ? set(selectedLandmarkIds.value, feature.getId(), true)
      : del(selectedLandmarkIds.value, feature.getId());
  };

  const selectLandmark = id => {
    const feature = source.getFeatureById(id);
    if (feature) {
      selectFeature(feature, true);
    }
  };

  const unselectAllLandmarks = () => {
    Object.keys(selectedLandmarkIds.value).forEach(id => {
      const feature = source.getFeatureById(id);
      if (feature) {
        feature.set('selected', false);
      }
    });
    selectedLandmarkIds.value = {};
  };

  const selectLandmarks = (ids = []) => {
    unselectAllLandmarks();
    ids.forEach(id => {
      selectLandmark(id);
    });
  };

  const unselectLandmark = id => {
    const feature = source.getFeatureById(id);
    if (feature) {
      selectFeature(feature, false);
    }
  };

  const clearLandmarks = () => {
    source.clear();
  };

  const enableEditLandmark = landmarkId => {
    interaction.setActive(true);
    const landmark = source.getFeatureById(landmarkId);
    if (landmark) {
      interaction.select(landmark, true);
    }
  };

  const disableEditLandmark = () => {
    interaction.setActive(false);
  };

  const getDefaultCenter = () => {
    const extent = map.getView().calculateExtent(map.getSize());
    const geom = fromExtent(extent);
    geom.scale(0.8);
    return transformCoordinatesToLonLat(getCenter(geom.getExtent()));
  };

  const toggleVisibleLandmarkLayer = () => {
    visibleLandmarkLayer.value = !visibleLandmarkLayer.value;
    landmarkLayer.setVisible(visibleLandmarkLayer.value);
  };

  const setVisibleLandmarkLayer = visible => {
    visibleLandmarkLayer.value = visible;
    landmarkLayer.setVisible(visibleLandmarkLayer.value);
  };

  return {
    setLandmarks,
    clearLandmarks,
    landmarkLayer,
    selectLandmark,
    selectLandmarks,
    unselectLandmark,
    unselectAllLandmarks,
    enableEditLandmark,
    disableEditLandmark,
    setMapToLandmarkCenter,
    selectedLandmarkIds,
    editLandmarksState,
    getDefaultCenter,
    toggleVisibleLandmarkLayer,
    visibleLandmarkLayer,
    setVisibleLandmarkLayer
  };
}
